import { downloadPdfFile, httpGet_New, httpPost_New } from './api.service';
import { PaginatedResult } from '../types/PaginatedResult';
import { UserGuideType } from '../types/UserGuideTypes';

export const getUserGuides = async (): Promise<PaginatedResult<UserGuideType>> => {
  const data = await httpGet_New<UserGuideType[]>('api/document/userguide/versions');

  const results = data || [];

  return {
    results,
    skipped: 0,
    totalCount: results.length,
    count: results.length,
    status: 200,
  };
};

export const downloadUserGuide = async (fileName: string): Promise<void> => {
  const url = `api/document/userguide?version=${fileName}`;
  await downloadPdfFile(url, fileName);
};

export const uploadUserGuide = async (file: File) => {
  const formData = new FormData();
  formData.append('File', file);
  return await httpPost_New('api/document/userguide', formData, true);
};
